import React, { Component } from "react";
import { connect } from "react-redux";
import "../../Assets/css/Login.css";
import Cover from "../../Assets/img/default-cover-image.svg";
import Header from "../../Components/MainLayout/Header";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class AboutSchool extends Component {
  state = {
    values: {
      contact: "",
      password: "",
    },
    schooldata: [],
    loading: false,
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "About";
  }

  render() {
    return (
      <div>
        <Header title="About" />
        <div
          className="th-login-cover"
          style={{
            backgroundImage: `url(${
              this.props.user.user.school?.dashboard_bg
                ? this.props.user.user.school?.dashboard_bg
                : Cover
            })`,
          }}
        ></div>

        <div style={{ zIndex: 10 }} className="container col-12 th-bg-white">
          <div className="d-flex pb-4 pt-4 align-items-center">
            <span>
              <div className="th-login-profile-wrap rounded">
                <div
                  className="th-login-profile"
                  style={{
                    height: "50px",
                    backgroundImage: `url(${
                      this.props.user.user.school.logo
                        ? this.props.user.user.school.logo
                        : Cover
                    })`,
                  }}
                ></div>
              </div>
            </span>
            <span className="th-16 th-medium pl-2">
              <p className="mb-0">{this.props.user.user.school.school_name}</p>
              <p className="mb-0 th-grey th-12">
                {this.props.user.user.school.school_address}
              </p>
            </span>
          </div>
          <hr className="mt-0" />
          <h6 className="th-primary th-14 my-4">Contacts</h6>

          <div className="row">
            {this.props.user.user.school.affliation_no ? (
              <>
                <div className="col-6">
                  <p className="th-black th-12">Affliation Number :</p>
                </div>
                <div className="col-6">
                  <p className="th-12 text-break">
                    {this.props.user.user.school.affliation_no}
                  </p>
                </div>
              </>
            ) : null}
            {this.props.user.user.school.office_no ? (
              <>
                <div className="col-6">
                  <p className="th-black th-12">Office Number :</p>
                </div>
                <div className="col-6">
                  <a
                    href={"tel:" + this.props.user.user.school.office_no}
                    style={{ textDecoration: "none" }}
                  >
                    <p className="th-black th-12 text-break">
                      {this.props.user.user.school.office_no}
                    </p>
                  </a>
                </div>
              </>
            ) : null}
            {this.props.user.user.school.help_no ? (
              <>
                <div className="col-6">
                  <p className="th-black th-12">Help Number :</p>
                </div>
                <div className="col-6">
                  <a
                    href={"tel:" + this.props.user.user.school.help_no}
                    style={{ textDecoration: "none" }}
                  >
                    <p className="th-black th-12 text-break">
                      {this.props.user.user.school.help_no}
                    </p>
                  </a>
                </div>
              </>
            ) : null}
            {this.props.user.user.school.email ? (
              <>
                <div className="col-6">
                  <p className="th-black th-12">Email :</p>
                </div>
                <div className="col-6">
                  <a
                    href={"mailto:" + this.props.user.user.school.email}
                    style={{ textDecoration: "none" }}
                  >
                    <p className="th-black th-12 text-break">
                      {this.props.user.user.school.email}
                    </p>
                  </a>
                </div>
              </>
            ) : null}
            {this.props.user.user.school.website_address ? (
              <>
                <div className="col-6">
                  <p className="th-black th-12">Website :</p>
                </div>
                <div className="col-6">
                  <a href={this.props.user.user.school.website_address}>
                    <p className="th-black th-12 text-break">
                      {this.props.user.user.school.website_address}
                    </p>
                  </a>
                </div>
              </>
            ) : null}
            {this.props.user.user.school.school_code ? (
              <>
                <div className="col-6">
                  <p className="th-black th-12">School Code :</p>
                </div>
                <div className="col-6">
                  <p className="th-12 text-break">
                    {this.props.user.user.school.school_code}
                  </p>
                </div>
              </>
            ) : null}
          </div>

          <div className="d-flex justify-content-center mt-5 pb-4">
            <div className="th-14 th-primary">
              Powered By : Gungun Erp Solution Pvt. Ltd.
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(AboutSchool);
